/**
 * @file Header
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Header component
 */
const vHeader = () => {
	const header = document.querySelector('.v-header');

	if (!header) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	gsap.set('header .gp-logo-cc', { transformOrigin: 'center center' });
	gsap.set('header .gp-logo-cc-mobile', { transformOrigin: 'center center' });

	/**
	 * Header animation
	 *
	 * @param {string} size window size
	 * @returns {gsap} timeline
	 */
	const headerAnimation = (size) => (
		gsap.timeline({
			scrollTrigger: {
				trigger: 'body',
				start:   `${wpPostData.isFrontPage ? 300 : 0}px top`,
				end:     '+=150px',
				scrub:   true,
				onLeave: () => {
					header.classList.add('v-header--stuck');
				},
				onEnterBack: () => {
					header.classList.remove('v-header--stuck');
				},
				onEnter: () => {
					header.classList.add('v-header--scrolled');
				},
				onLeaveBack: () => {
					header.classList.remove('v-header--scrolled');
				},
			},
			defaults: {
				ease: 'sine.out',
			},
		})
			.fromTo('.v-header', { scaleY: 1 }, {
				scaleY:   size === 'xsmall' ? 0.85 : 0.705,
				onUpdate: () => {
					const scaleY = gsap.getProperty('.v-header', 'scaleY');
					gsap.set('.v-header__inner', {
						scaleY: 1 / scaleY,
					});
				},
			})
			.fromTo('.v-header__logo-link', { '--ratio': '19.274016%' }, {
				'--ratio': '11%',
			}, '<')
			.fromTo(['header .gp-logo-cc', 'header .gp-logo-cc-mobile'], { opacity: 1, scale: 1 }, {
				opacity: 0,
				scale:   0.3,
			}, '<')
			.fromTo('.v-header__donate-link', { '--padding-y': size === 'large' ? '.9em' : '.657em' }, {
				'--padding-y': '.6em',
			}, '<')
			.fromTo('.v-header__donate, .v-header__share', { opacity: wpPostData.isFrontPage ? 0 : 1 }, {
				opacity: 1,
			}, '<')
	);

	ScrollTrigger.saveStyles('.v-header__donate-link', '.v-header');
	ScrollTrigger.matchMedia({
		'(min-width: 1024.1px)': () => {
			headerAnimation('large');
		},
		'(max-width: 1024px) and (min-width: 550.1px)': () => {
			headerAnimation('small');
		},
		'(max-width: 550px)': () => {
			headerAnimation('xsmall');
		},
	});
};

export default vHeader;
